import React, { useState, useRef } from 'react';

import Footer from '../components/footer/index';
import HeroSection from '../components/produk_TV/hero_section';
import PromoOffers from '../components/produk_TV/promo_offers';
import Paket from '../components/produk_TV/paket';
import Benefits from '../components/produk_TV/benefits';
import Channel from '../components/produk_TV/channel';
import Section from '../components/produk_TV/section';

const TVIPTVPage = () => {
  const [ setSelectedPackage] = useState(null);
  const [activeTab, setActiveTab] = useState('semua');
  const [] = useState(false);
  const paketRef = useRef(null);
  const [] = useState({
    days: 5,
    hours: 8,
    minutes: 23,
    seconds: 15
  });

  // const comparisonFeatures = [
  //   'Jumlah Saluran',
  //   'Kualitas Video',
  //   'Jumlah Device',
  //   'Cloud DVR Storage',
  //   'Catch-up Duration',
  //   'Premium Channels',
  //   'Kids Channels',
  //   'Sports Channels',
  //   'VOD Library',
  //   'Multi-screen'
  // ];

   const scrollToPaket = () => {
    if (paketRef.current) {
      paketRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };


  const packages = [
    {
      id: 'home-basic',
      category: 'home',
      speed: '100 Mbps',
      name: 'NetSpeed Home Basic',
      description: 'Perfect untuk streaming HD dan browsing keluarga sehari-hari',
      price: 'Rp 299.000',
      originalPrice: 'Rp 399.000',
      discount: '25%',
      badge: 'PROMO',
      badgeColor: 'bg-red-500',
      popular: false,
      features: [
        { name: '10 devices', icon: '/image/mobile.png' },
        { name: 'Unlimited data', icon: '/image/icon/unlimeted.png' },
        { name: 'Support 24/7', icon: '/image/icon/support.png' },
        { name: 'Free installation', icon: '/image/icon/free_installation.png' },
        { name: 'Router included', icon: '/image/icon/router.png' },
        { name: 'Speed up to 100 Mbps', icon: '/image/icon/speed.png' }
      ],
      ideal: ['Browsing internet', 'Streaming HD', 'Video call', 'Social media'],
      devices: '10 devices',
      installation: 'GRATIS',
      support: '24/7',
      sla: '-'
    },
    {
      id: 'home-pro',
      category: 'home',
      speed: '500 Mbps',
      name: 'NetSpeed Home Pro',
      description: 'Ideal untuk gaming dan streaming 4K multiple device',
      price: 'Rp 499.000',
      originalPrice: 'Rp 649.000',
      discount: '23%',
      badge: 'POPULER',
      badgeColor: 'bg-blue-900',
      popular: true,
      features: [
        { name: '20 devices', icon: '/image/mobile.png' },
        { name: 'Unlimited data', icon: '/image/icon/unlimeted.png' },
        { name: 'Priority support', icon: '/image/icon/priority.png' },
        { name: 'Free router premium', icon: '/image/icon/router.png' },
        { name: 'Gaming optimization', icon: '/image/icon/gaming.png' },
        { name: 'Speed up to 500 Mbps', icon: '/image/icon/speed.png' }
      ],
      ideal: ['Gaming online', 'Streaming 4K', 'Work from home', 'Multiple users'],
      devices: '20 devices',
      installation: 'GRATIS',
      support: 'Priority 24/7',
      sla: '-'
    },
    {
      id: 'gaming-ultra',
      category: 'gaming',
      speed: '1 Gbps',
      name: 'NetSpeed Gaming Ultra',
      description: 'Zero lag gaming dengan ping <10ms dan kecepatan ultra',
      price: 'Rp 799.000',
      originalPrice: 'Rp 999.000',
      discount: '20%',
      badge: 'GAMING',
      badgeColor: 'bg-green-600',
      popular: false,
      features: [
        { name: '30+ devices', icon: '/image/mobile.png' },
        { name: 'Unlimited data', icon: '/image/icon/unlimeted.png' },
        { name: 'Gaming optimization', icon: '/image/icon/gaming.png' },
        { name: 'Static IP', icon: '/image/icon/IP_STATIC.png' },
        { name: 'Low latency <10ms', icon: '/image/icon/speed.png' },
        { name: 'Speed up to 1 Gbps', icon: '/image/icon/speed.png' }
      ],
      ideal: ['Pro gaming', 'Live streaming', 'Content creation', 'Heavy download'],
      devices: '30+ devices',
      installation: 'GRATIS',
      support: 'Gaming Support 24/7',
      sla: '-'
    },
    {
      id: 'business-enterprise',
      category: 'business',
      speed: 'Dedicated',
      name: 'Business Enterprise',
      description: 'Bandwidth dedicated dengan SLA 99.9% untuk kebutuhan bisnis',
      price: 'Custom Pricing',
      originalPrice: null,
      discount: null,
      badge: 'BISNIS',
      badgeColor: 'bg-blue-600',
      popular: false,
      features: [
        { name: 'Custom devices', icon: '/image/mobile.png' },
        { name: 'Unlimited data', icon: '/image/icon/unlimeted.png' },
        { name: 'Dedicated support', icon: '/image/icon/priority.png' },
        { name: 'SLA 99.9%', icon: '/image/icon/SLA.png' },
        { name: 'Static IP', icon: '/image/icon/IP_STATIC.png' },
        { name: 'Dedicated bandwidth', icon: '/image/icon/Dedicated.png' }
      ],
      ideal: ['Office operations', 'E-commerce', 'Data center', 'Enterprise apps'],
      devices: 'Unlimited',
      installation: 'Konsultasi',
      support: 'Dedicated 24/7',
      sla: '99.9%'
    }
  ];

  // const tvPackages = [
  //   {
  //     id: 'basic-tv',
  //     category: 'basic',
  //     channels: '150+',
  //     name: 'NetTV Basic',
  //     description: 'Paket dasar dengan saluran lokal dan internasional populer',
  //     price: 'Rp 149.000',
  //     originalPrice: 'Rp 199.000',
  //     discount: '25%',
  //     badge: 'HEMAT',
  //     badgeColor: 'bg-green-500',
  //     popular: false,
  //     features: [
  //       { name: '150+ saluran', icon: '📺' },
  //       { name: 'HD Quality', icon: '📽️' },
  //       { name: '5 devices', icon: '📱' },
  //       { name: 'EPG (Electronic Program Guide)', icon: '📋' },
  //       { name: 'Pause & Resume', icon: '⏸️' },
  //       { name: '7-day catch up', icon: '⏮️' }
  //     ],
  //     channels_detail: {
  //       'Lokal': 25,
  //       'Berita': 15,
  //       'Olahraga': 10,
  //       'Film': 20,
  //       'Anak-anak': 15,
  //       'Musik': 10,
  //       'Dokumenter': 8,
  //       'Lifestyle': 12,
  //       'Internasional': 35
  //     },
  //     ideal: ['Keluarga', 'Hiburan sehari-hari', 'Berita lokal', 'Film populer'],
  //     devices: '5 devices',
  //     quality: 'HD 720p',
  //     recording: 'Cloud DVR 50GB',
  //     support: '24/7'
  //   },
  //   {
  //     id: 'premium-tv',
  //     category: 'premium',
  //     channels: '300+',
  //     name: 'NetTV Premium',
  //     description: 'Paket lengkap dengan saluran premium dan konten eksklusif',
  //     price: 'Rp 299.000',
  //     originalPrice: 'Rp 399.000',
  //     discount: '25%',
  //     badge: 'POPULER',
  //     badgeColor: 'bg-purple-600',
  //     popular: true,
  //     features: [
  //       { name: '300+ saluran', icon: '📺' },
  //       { name: '4K Ultra HD', icon: '🎬' },
  //       { name: '10 devices', icon: '📱' },
  //       { name: 'Premium channels', icon: '⭐' },
  //       { name: 'VOD Library 10,000+', icon: '🎭' },
  //       { name: '30-day catch up', icon: '⏮️' },
  //       { name: 'Multi-screen viewing', icon: '📺' },
  //       { name: 'Parental control', icon: '🔒' }
  //     ],
  //     channels_detail: {
  //       'Lokal': 30,
  //       'Berita': 25,
  //       'Olahraga': 30,
  //       'Film Premium': 40,
  //       'HBO & Showtime': 15,
  //       'Anak-anak': 25,
  //       'Musik': 20,
  //       'Dokumenter': 20,
  //       'Lifestyle': 25,
  //       'Internasional': 70
  //     },
  //     ideal: ['Keluarga besar', 'Pecinta film', 'Sports enthusiast', 'Premium content'],
  //     devices: '10 devices',
  //     quality: '4K Ultra HD',
  //     recording: 'Cloud DVR 200GB',
  //     support: 'Priority 24/7'
  //   },
  //   {
  //     id: 'sports-tv',
  //     category: 'sports',
  //     channels: '200+',
  //     name: 'NetTV Sports',
  //     description: 'Paket khusus olahraga dengan semua liga dan turnamen dunia',
  //     price: 'Rp 399.000',
  //     originalPrice: 'Rp 499.000',
  //     discount: '20%',
  //     badge: 'SPORTS',
  //     badgeColor: 'bg-orange-600',
  //     popular: false,
  //     features: [
  //       { name: '200+ saluran', icon: '📺' },
  //       { name: '50+ saluran olahraga', icon: '⚽' },
  //       { name: '4K Sports streaming', icon: '🏆' },
  //       { name: 'Live scores & stats', icon: '📊' },
  //       { name: 'Multi-angle viewing', icon: '📹' },
  //       { name: 'Instant replay', icon: '🔄' },
  //       { name: 'Match highlights', icon: '🎯' },
  //       { name: 'Sports VOD', icon: '🥅' }
  //     ],
  //     channels_detail: {
  //       'Football/Soccer': 15,
  //       'Basketball': 8,
  //       'Tennis': 6,
  //       'Golf': 5,
  //       'Motor Sports': 8,
  //       'Combat Sports': 6,
  //       'Olympic Sports': 10,
  //       'Local Sports': 5,
  //       'Entertainment': 137
  //     },
  //     ideal: ['Sports fans', 'Live match viewing', 'Tournament coverage', 'Sports analysis'],
  //     devices: '15 devices',
  //     quality: '4K Sports',
  //     recording: 'Sports DVR 500GB',
  //     support: 'Sports Expert 24/7'
  //   },
  //   {
  //     id: 'family-tv',
  //     category: 'family',
  //     channels: '250+',
  //     name: 'NetTV Family',
  //     description: 'Paket keluarga dengan kontrol orang tua dan konten anak',
  //     price: 'Rp 249.000',
  //     originalPrice: 'Rp 329.000',
  //     discount: '24%',
  //     badge: 'FAMILY',
  //     badgeColor: 'bg-pink-600',
  //     popular: false,
  //     features: [
  //       { name: '250+ saluran', icon: '📺' },
  //       { name: '80+ kids channels', icon: '🧸' },
  //       { name: 'Parental controls', icon: '👨‍👩‍👧‍👦' },
  //       { name: 'Educational content', icon: '📚' },
  //       { name: 'Kids VOD library', icon: '🎪' },
  //       { name: 'Safe browsing', icon: '🛡️' },
  //       { name: 'Time limits', icon: '⏰' },
  //       { name: 'Content filtering', icon: '🔍' }
  //     ],
  //     channels_detail: {
  //       'Anak-anak': 80,
  //       'Pendidikan': 20,
  //       'Keluarga': 30,
  //       'Film Family': 25,
  //       'Kartun': 35,
  //       'Musik Anak': 15,
  //       'Dokumenter Anak': 10,
  //       'Lifestyle': 20,
  //       'Lainnya': 15
  //     },
  //     ideal: ['Keluarga dengan anak', 'Konten edukatif', 'Kontrol orang tua', 'Hiburan aman'],
  //     devices: '8 devices',
  //     quality: 'HD Family Safe',
  //     recording: 'Family DVR 100GB',
  //     support: 'Family Support 24/7'
  //   }
  // ];

    // const filteredPackages = activeTab === 'semua' ? packages : packages.filter(pkg => pkg.category === activeTab);

  // Promo countdown timer
  
  // const getComparisonValue = (pkg, feature) => {
  //   switch (feature) {
  //     case 'Jumlah Saluran': return pkg.channels;
  //     case 'Kualitas Video': return pkg.quality;
  //     case 'Jumlah Device': return pkg.devices;
  //     case 'Cloud DVR Storage': return pkg.recording;
  //     case 'Catch-up Duration': return pkg.features.find(f => f.name.includes('catch up'))?.name || '❌';
  //     case 'Premium Channels': return pkg.features.some(f => f.name.includes('Premium') || f.name.includes('HBO')) ? '✅' : '❌';
  //     case 'Kids Channels': return pkg.channels_detail['Anak-anak'] ? `${pkg.channels_detail['Anak-anak']}+` : '❌';
  //     case 'Sports Channels': return pkg.channels_detail['Olahraga'] || pkg.channels_detail['Football/Soccer'] ? '✅' : '❌';
  //     case 'VOD Library': return pkg.features.some(f => f.name.includes('VOD')) ? '✅' : '❌';
  //     case 'Multi-screen': return pkg.features.some(f => f.name.includes('Multi-screen')) ? '✅' : '❌';
  //     default: return '-';
  //   }
  // };

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100">
      <style>    
        {`
        .hero-gradient {
            background: linear-gradient(135deg, #1a1a1a 0%, #1e2a47 50%, #050c9dff 100%);
          }
          
          .package-card {
            transition: all 0.3s ease;
            background: linear-gradient(145deg, #1f2937, #111827);
          }
          
          .package-card:hover {
            transform: translateY(-10px);
            box-shadow: 0 25px 50px -12px rgba(139, 92, 246, 0.4);
          }
          
          .package-card.popular {
            border: 2px solid #050c9dff;
            position: relative;
          }
          
          .package-card.popular::before {
            content: '';
            position: absolute;
            top: -2px;
            left: -2px;
            right: -2px;
            bottom: -2px;
            background: linear-gradient(45deg, #1a1a1a, #050c9dff, #1a1a1a);
            border-radius: inherit;
            z-index: -1;
            animation: borderGlow 3s ease-in-out infinite;
          }
          
          @keyframes borderGlow {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
          
          .feature-icon {
            background: linear-gradient(135deg, #1e2a47 , #050c9dff);
            border-radius: 50%;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
          }
          
          .promo-card {
            transition: all 0.3s ease;
          }
          
          .promo-card:hover {
            transform: translateY(-5px);
          }
          
          .comparison-table {
            background: linear-gradient(145deg, #1f2937, #111827);
          }
          
          .tab-button.active {
            background: linear-gradient(135deg, #1e2a47, #050c9dff);
          }
          
          .countdown-item {
            background: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255, 255, 255, 0.2);
          }
          
          .glass-effect {
            background: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255, 255, 255, 0.2);
          }
          
          .pulse-animation {
            animation: pulse 2s infinite;
          }
          
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.05); }
            100% { transform: scale(1); }
          }
        `}
      </style>
      
      
      {/* Hero Section */}
      <HeroSection scrollToPaket={scrollToPaket} /> 

      {/* Promo & Offers Section */}
      <PromoOffers />

      {/* Package Filter Tabs */}
       <Paket
       ref={paketRef}
       packages={packages}
       activeTab={activeTab}
       setActiveTab={setActiveTab}
       setSelectedPackage={setSelectedPackage}
      />

      {/* Features & Benefits Section */}
      <Benefits />
      {/* Popular Channels Showcase */}
      <Channel />
      
      {/* Call to Action Section */}
      <Section />

      <Footer />
    </div>
  );
};

export default TVIPTVPage;